import { tWithKeyAttr as t } from "../../../i18nHelper";
import popupStyles from "./updateUserInfoSuccessPopup.module.css";
import venchyImg from "../../../images/questionnaire_doctor.png";
import { IPopupWithoutProps } from "../../../types/types";

function UpdateUserInfoSuccessPopup({ onClose }: IPopupWithoutProps) {
  return (
    <article className={popupStyles.popup}>
      <h2 className={popupStyles.popup__title}>
        {t("UPDATE_USER_INFO_SUCCESS_TITLE")}
      </h2>
      <p className={popupStyles.popup__text}>
        {t("UPDATE_USER_INFO_SUCCESS_TEXT")}
      </p>
      <img
        src={venchyImg}
        alt={t("IMAGE_ALT_VENCHY_DOCTOR")}
        className={popupStyles.popup__img}
      />
      <button
        className={`button hover ${popupStyles.popup__nextBtn}`}
        onClick={onClose}
      >
        {t("UPDATE_USER_INFO_SUCCESS_BUTTON")}
      </button>
    </article>
  );
}

export default UpdateUserInfoSuccessPopup;
